export default {
  name: "",
  components: {},
  props: ["billing", "publicKey"],
  data() {
    return {
      valid: false,
      stripe: null,
      card: null,
      clientToken: null,
      loading: false
    };
  },
  computed: {},
  async created() {},
  async mounted() {
    if (this.publicKey) {
      this.$nextTick(() => {
        this.LoadStripeScript();
      });
    }
  },
  methods: {
    async GetToken() {
      return this.$helpers.PostApi("get/token");
    },

    LoadStripeScript() {
      let script = document.getElementById("stripe");

      if (!script) {
        script = document.createElement("script");
        script.setAttribute("src", "https://js.stripe.com/v3/");
        script.setAttribute("id", "stripe");
        document.head.appendChild(script);
        script.onload = async () => {
          this.Init();
        };
      } else {
        this.Init();
      }
    },

    async Init() {
      this.stripe = window.Stripe(this.publicKey);
      let elements = this.stripe.elements();
      this.card = elements.create("card");

      this.card.addEventListener("change", event => {
        if (event.error) {
          this.valid = false;
        } else {
          if (event.complete) {
            this.valid = true;
          }
        }
      });
      this.card.mount("#card");
    },

    async CardSetup() {
      if (this.valid) {
        this.loading = true;

        let result = await this.stripe.confirmCardSetup(await this.GetToken(), {
          payment_method: {
            card: this.card,
            billing_details: {
              name: `${this.billing.firstName} ${this.billing.lastName}`,
              email: this.$store.state.auth.user.username,
              address: {
                postal_code: this.billing.postalCode,
                country: this.billing.countryShort,
                line1: this.billing.streetAddress
              }
            }
          }
        });

        if (result.error) {
          this.$helpers.ShowStatus(result.error.message, 5000, "warning");
          this.loading = false;
        } else {
          try {
            // let paymentRes = await this.$helpers.PostApi(
            //   "create/paymentMethod",
            //   {
            //     paymentMethod: result.setupIntent.payment_method
            //   },
            //   false,
            //   false
            // );

            this.$emit("saved");
            this.loading = false;
            this.$helpers.ShowStatus(
              "New card has been added.",
              5000,
              "success"
            );
          } catch (err) {
            if (err.response.status === 409) {
              this.$helpers.ShowStatus(
                "The card already exists.",
                5000,
                "warning"
              );

              this.loading = false;
            }
          }
        }
      }
    }
  }
};
